import { Image, ImageProps } from 'theme-ui'

const Sky = (props: ImageProps) => {
  return (
    <Image width={16} src="https://storage.reserve.org/sky.svg" {...props} />
  )
}
export default Sky
